import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Image } from '../image';
import { Slot } from '../slot';
import { propertyCardMLSLogoStyles } from './styles/property-card-mls-logo.styles';
import type { PropertyCardMLSLogoPropsInterface } from './types/property-card-mls-logo.types';

/**
 * Displays an MLS logo.
 *
 * @since 8.64.2
 */
export const PropertyCardMLSLogo = forwardRef<HTMLDivElement, PropertyCardMLSLogoPropsInterface>(
  (props: PropertyCardMLSLogoPropsInterface, forwardedRef) => {
    const {
      asChild = false,
      attribution = '',
      children,
      className,
      css: cssProp,
      logoSrc,
      ...rest
    } = props;

    const styles = css(propertyCardMLSLogoStyles, cssProp);

    const Component = asChild ? Slot : Image;

    return (
      <div
        ref={forwardedRef}
        data-c11n-component="PropertyCard.MLSLogo"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_property-card__mls-logo', styles, className)}
        {...rest}
      >
        <Component src={logoSrc} alt={attribution}>
          {children}
        </Component>
      </div>
    );
  },
);

PropertyCardMLSLogo.displayName = 'PropertyCard.MLSLogo';
